<section class="h-full" [attr.aria-labelledby]="headerLabelId">
  <mat-card
    class="widget-card bg-white"
    [class.edit-mode]="isEditMode"
    [class.loading]="isLoading()"
    [class.error]="hasError()"
    appearance="raised"
  >
    <!-- Widget Header -->
    <mat-card-header
      class="widget-header"
      [ngClass]="
        (widget.type === WidgetType.TABLE ||
          widget.type === WidgetType.CARD ||
          widget.type === WidgetType.INFO_DETAIL) &&
        !hasError() &&
        !isLoading() &&
        !isEditMode
          ? 'sr-only!'
          : 'block'
      "
    >
      <div class="widget-title">
        @if (widget.icon) {
          <mat-icon class="widget-icon material-icons-outlined">{{
            widget.icon
          }}</mat-icon>
        }
        <div class="title-content">
          <h3 class="widget-name" [id]="'h3' + widget.id">
            {{ (widget.headerConfig?.titleKey || widget.title) | translate }}
          </h3>
          @if (widget.lastUpdated) {
            <p class="widget-subtitle">
              Aggiornato: {{ getLastUpdatedTime() }}
            </p>
          }
        </div>
      </div>

      <!-- Edit Mode Controls -->
      @if (isEditMode) {
        <div class="widget-controls">
          <button
            mat-icon-button
            cdkDragHandle
            class="drag-handle"
            title="Sposta widget"
            aria-label="sposta componente"
            matTooltip="Sposta elemento"
          >
            <mat-icon class="material-icons-outlined">drag_indicator</mat-icon>
          </button>
          <button
            mat-icon-button
            class="remove-btn"
            (click)="onRemove()"
            title="Rimuovi widget"
            aria-label="Chiudi componente"
            matTooltip="Chiudi elemento"
          >
            <mat-icon class="material-icons-outlined">close</mat-icon>
          </button>
        </div>
      }

      <!-- Refresh Button (always visible) -->
      @if (
        !isEditMode && widget.type === WidgetType.LIST && widget.config.path
      ) {
        <div class="flex justify-end">
          <a
            matButton
            class="edit-toggle underline!"
            tabindex="0"
            (click)="openFullList()"
            (keydown.enter)="openFullList()"
            (keydown.space)="openFullList()"
            [attr.aria-label]="
              ('GENERAL.viewAll' | translate) + ' ' + (widget.title | translate)
            "
            matTooltip="Visualizza elenco completo"
          >
            {{ 'GENERAL.viewAll' | translate }}
            <mat-icon iconPositionEnd class="ms-2 material-icons-outlined"
              >arrow_forward</mat-icon
            >
          </a>
        </div>
      }
    </mat-card-header>

    <!-- Widget Content -->
    <mat-card-content class="widget-content">
      <!-- Loading State -->
      @if (isLoading()) {
        <div class="widget-loading">
          <mat-icon class="spinning material-icons-outlined">refresh</mat-icon>
          <p>Caricamento...</p>
        </div>
      }

      <!-- Error State -->
      @if (hasError() && !isLoading()) {
        <div class="widget-error">
          <mat-icon class="error-icon material-icons-outlined"
            >error_outline</mat-icon
          >
          <p>Errore nel caricamento dei dati</p>
          <button mat-stroked-button (click)="onRefresh()" class="retry-btn">
            Riprova
          </button>
        </div>
      }

      <!-- Widget Content Slot -->
      @if (!isLoading() && !hasError()) {
        <div class="widget-body">
          <ng-content></ng-content>
        </div>
      }
    </mat-card-content>
  </mat-card>
</section>
